import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { images } from '../../data/images';
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-ink py-24 md:py-32" data-id="element-118" data-mp="22cksay0sgldk">
      <img src={images.coach} alt="" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-119" data-mp="1nnybervijlk8" />
      <div className="absolute inset-0 bg-ink/80" aria-hidden="true" data-id="element-120" data-mp="1slztpal47gun" />
      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-121" data-mp="1enib1ra2gujl">
        <h2 className="font-display text-5xl font-black uppercase leading-[0.9] text-white sm:text-7xl" data-id="element-122" data-mp="1iq56s39uyzm2">
          Deja de adivinar. <span className="text-brand" data-id="element-123" data-mp="14rf7qi3hapv2">Empieza con claridad.</span>
        </h2>
        <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-124" data-mp="19of5m5q6cmb3">
          Si quieres perder grasa, ganar músculo y sentirte mejor, pero no sabes exactamente qué está fallando, este
          diagnóstico es el primer paso.
        </p>
        <div className="mx-auto mt-6 max-w-2xl space-y-1 text-lg text-white" data-id="element-125" data-mp="340vg5iq06mlr">
          <p data-id="element-126" data-mp="27a789r6xrfn">No necesitas otra rutina al azar.</p>
          <p data-id="element-127" data-mp="3tg7nmrpc2bzr">Necesitas entender tu situación y saber qué camino tomar.</p>
        </div>
        <div className="mt-10 flex flex-col items-center gap-4" data-id="element-128" data-mp="b16r1hwvurrw">
          <CtaButton className="w-full sm:w-auto" data-id="element-129" data-mp="b3j7fqmzsu2u" />
          <p className="text-sm text-muted" data-id="element-130" data-mp="6zlcls4pa5fl">Gratis. Sin compromiso. Solo claridad sobre tu próximo paso.</p>
        </div>
      </div>
    </section>;
}